class DeferredAccount extends HTMLElement {
  connectedCallback() {
    if (this.hasAttribute('loaded')) return;
    this.activate = this.activate.bind(this);
    const drawer = this.closest('menu-drawer');
    if (drawer) {
      this.drawerObserver = new MutationObserver(() => {
        if (!drawer.hidden) this.activate();
      });
      this.drawerObserver.observe(drawer, {attributes:true, attributeFilter:['hidden']});
    }
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting) && getComputedStyle(this).visibility !== 'hidden') this.activate();
      });
      this.observer.observe(this);
    } else {
      this.activate();
    }
  }

  activate() {
    if (this.hasAttribute('loaded')) return;
    const template = this.querySelector('template');
    if (!template) return;
    this.setAttribute('loaded', '');
    this.observer?.disconnect();
    this.drawerObserver?.disconnect();
    const fallback = this.querySelector('[data-account-fallback]');
    const fragment = template.content.cloneNode(true);
    const account = fragment.querySelector('shopify-account');
    account.style.display = 'none';
    this.append(fragment);
    template.remove();
    customElements.whenDefined('shopify-account').then(() => {
      let attempts = 0;
      const ready = () => {
        if (!this.isConnected) return;
        const button = account.shadowRoot?.querySelector('button, a, [tabindex="0"]');
        if (button) {
          const hadFocus = fallback === document.activeElement;
          account.style.removeProperty('display');
          fallback?.remove();
          if (hadFocus) button.focus();
        } else if (++attempts < 100) {
          this.readinessTimer = setTimeout(ready, 50);
        }
      };
      ready();
    });
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.drawerObserver?.disconnect();
    clearTimeout(this.readinessTimer);
  }
}
if (!customElements.get('deferred-account')) customElements.define('deferred-account', DeferredAccount);
